"use client"

import { CameraOff } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CameraOffIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CameraOffIcon = component(Icon)({ as: CameraOff })
